<script>
import BaseMixin from './mixins/base';

export default {
    name: 'ZipCodeField',
    mixins: [BaseMixin],
};
</script>

<template>
    <input
        class="form-control"
        ref="field"
        type="text"
        :disabled="disabled"
        :name="name"
        :placeholder="placeholder"
        :readonly="readonly"
        :required="required"
        :value="value"
        @blur="onBlur"
        @focus="onFocus"
        @change="onChange"
        @input="onInput"
        />
</template>
